import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { withToggle } from "../withToggle";

const CancelledMembers = ({ qa }) => {
  const {
    canceledMembersNumber,
    canceledMembersLink,
    canceledMembersPercentChange,
    prevCanceledMembersNumber,
    prevCanceledMembersLink,
    tooltip
  } = useSelector((state) => state.membershipUnits.membershipUnits.totalNewMembers.canceledMembers);

  return (
    <>
      <div className="content__el">
        <DataDisplay
          label="Cancelled Members"
          type="number"
          value={canceledMembersNumber}
          url={canceledMembersLink}
          disableAnimation={qa}
          toolTipContent={tooltip}
          toolTipId="membershipUnitsCancelMembers"
          changeProps={{
            changeValue: canceledMembersPercentChange,
            toolTip: "Percentage change from previous month",
            showBorder: true,
            positiveColor: "#c7343e",
            negativeColor: "#21e981"
          }}
        />
      </div>
      <PreviousCancelledMembers
        title="Previous Cancelled Members"
        commonProps={{
          toolTipContent: `Previous ${tooltip}`,
          toolTipId: "membershipUnitsPrevCancelMembers"
        }}
        dataPointProps={{
          type: "number",
          value: prevCanceledMembersNumber,
          url: prevCanceledMembersLink,
          disableAnimation: qa
        }}
      />
    </>
  );
};

const PreviousCancelledMembers = withToggle(DataDisplay);

export default CancelledMembers;
